export default "__VITE_ASSET__BN4ETm1h__"